import React, { useState, useRef } from "react";
import ReportViewer from "../Reports/ReportViewerComponent";
import { RadioGroup, Checkbox } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { Dialog } from "@progress/kendo-react-dialogs";
import { ReportURL } from "api/axios.config";
import { FormComboBox } from "components/Matters";

const BillingGuideModal = (props) => {
    const DateFormat = (value) => {
        let date = new Date(value);
        return date.toISOString().split("T")[0];
    };
    const typesData = [
        {
            label: "All Time",
            value: "All",
        },
        {
            label: "Billed Time",
            value: "Billed",
        },
        {
            label: "Unbilled Time",
            value: "Unbilled",
        },
    ];
    const groupByOptions = [
        { label: "Activity Type", value: "ActivityType" },
        { label: "Fee Earner", value: "FeeEarnerRef" },
        { label: "Date", value: "Date" },
    ];
    let date = new Date();
    const [fromDate, setFromDate] = React.useState(date);
    const [groupByState, setGroupByState] = useState({ groupBy: null });

    const analyzeParameters = () => {
        setParameters({
            TimeTime: type,
            IncludeDisb: includeDisb,
            ToDate: includeEndDate ? DateFormat(endDate) : undefined,
            fromDate: includeFromDate ? DateFormat(fromDate) : undefined,
            matterID: props?.matterId,
            GroupBy: groupByState.groupBy ? groupByState.groupBy.value : null,
        });
        setShouldLoad(true);
        setShowReport(true);
    };

    const saveActivityRef = useRef(false);

    const [type, setType] = useState(typesData[0].value);
    const [loading, setLoading] = useState(false);
    const [includeFromDate, setIncludeFromDate] = useState(false);
    const [includeEndDate, setIncludeEndDate] = useState(false);
    const [includeDisb, setIncludeDisb] = useState(true);
    const [shouldLoad, setShouldLoad] = useState(false);    
    const [endDate, setEndDate] = React.useState(date);
    const [parameters, setParameters] = useState({
        TimeTime: type,
        IncludeDisb: includeDisb,
        ToDate: includeEndDate ? DateFormat(endDate) : undefined,
        matterID: props?.matterId,
        GroupBy: groupByState.groupBy ? groupByState.groupBy.value : null,
    });
    const [showReport, setShowReport] = useState(false);
    const [exportFunction, setExportFunction] = useState(false);

    const handleExport = () => {
        saveActivityRef.current = true;
        setLoading(true);
        setExportFunction(true);
    };

    const onChangeFromDateSelect = (event) => {
        setFromDate(event.value);
        setIncludeFromDate(true);
    };
    const onChangeEndSelect = (event) => {
        setEndDate(event.value);
        setIncludeEndDate(true);
    };
    const UpdateButton = (
        <Button className="common-btn" onClick={analyzeParameters}>
            OK
        </Button>
    );
    const fromDatePicker = (
        <div className="d-flex align-items-center justify-content-center">
            <Checkbox
                // defaultChecked={false}
                value={includeFromDate}
                className="ms-2 me-1 mt-auto mb-auto"
                onChange={(e) => {
                    setIncludeFromDate(e.value);
                }}
                label={""}
            />
            <DatePicker
                id="dp"
                className="date-picker"
                value={fromDate || null}
                onChange={onChangeFromDateSelect}
                toggleButton={CalenderCustomToggleButton}
            />
        </div>
    );
    const toDatePicker = (
        <div className="d-flex align-items-center justify-content-center">
            <Checkbox
                value={includeEndDate}
                className="ms-2 me-1 mt-auto mb-auto"
                onChange={(e) => {
                    setIncludeEndDate(e.value);
                }}
                label={""}
            />
            <DatePicker
                id="to"
                className="date-picker"
                value={endDate || null}
                onChange={onChangeEndSelect}
                toggleButton={CalenderCustomToggleButton}
            />
        </div>
    );
    const radioGroup = (
        <RadioGroup
            className=""
            data={typesData}
            value={type}
            onChange={(e) => {
                setType(e.value);
            }}
        />
    );
    const IncludeCheckbox = (
        <Checkbox
            // defaultChecked={false}
            value={includeDisb}
            className="checkbox-label"
            onChange={(e) => {
                setIncludeDisb(e.value);
            }}
            label={"Include Disbursement"}
        />
    );
    const handleGroupByChange = (e, name) => {
        setGroupByState((prev) => ({
            ...prev,
            [name]: e.value || null,
        }));
    };

    const reportViewer = (
        <ReportViewer
            modalHeight={"100%"}
            name="BillingGuide.trdp"
            matterID={props?.matterId}
            saveActivityRef={saveActivityRef}
            parameters={parameters}
            shouldLoad={shouldLoad}
            url={`${ReportURL}/Reporting/reports`}
            exportCallback={() => {
                console.log("exportCallback called");
                setExportFunction(false);
                setLoading(false);                
                
                if (saveActivityRef.current) {
                    setShowReport(false);
                    saveActivityRef.current = false;
                }

            }}
            exportFunction={exportFunction}
            setShouldLoad={setShouldLoad}
        />
    );

    return (
        <>
            <Dialog
                title={"Billing Guide"}
                onClose={props?.onClose}
                width={"36vw"}
                minWidth={"600px"}
            >
                <div className="px-5 mx-3 py-4 ">
                    <div className={`row py-2 `}>
                        <Label className="label fw-bold  ">Date</Label>
                        <div className=" my-2  border-bottom border-opacity-50"></div>

                        <div className="col ">
                            <Label className="label mb-1">From</Label>
                            <div className="no-borders">{fromDatePicker}</div>
                        </div>

                        <div className="col ">
                            <Label className="label mb-1 ">To</Label>
                            <div className="no-borders">{toDatePicker}</div>
                        </div>
                    </div>
                    <div>
                        <div className=" mt-3  ">
                            <Label className="label fw-bold  ">Show Time</Label>
                            <div className=" my-2  border-bottom border-opacity-50"></div>

                            <div className="py-2 d-flex radio flex-row radio-horizontal">
                                {radioGroup}
                            </div>
                        </div>

                        <FormComboBox
                            isStyled={true}
                            className="mt-4 mb-5"
                            width={"230px"}
                            wf={true}
                            name="groupBy"
                            label={"Group By"}
                            textField="label"
                            data={groupByOptions}
                            state={groupByState}
                            onChangeComboBox={handleGroupByChange}
                        />
                        <div className="my-2  border-bottom border-opacity-50"></div>

                        <div className="py-3">{IncludeCheckbox}</div>
                    </div>
                </div>
                <div className="dialog-footer">
                    <div className="me-3">{UpdateButton}</div>
                </div>
            </Dialog>

            {showReport && (
                <Dialog
                    title={"Billing Guide Report"}
                    onClose={() => setShowReport(false)}
                    className="dialog-lg h-100"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="mb-2 px-4 flex-grow-1 ">
                            {reportViewer}
                        </div>
                        <div className="dialog-footer">
                            <Button
                                className="common-btn bgBtnSecondary me-2"
                                onClick={() => setShowReport(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleExport}
                                disabled={loading}
                                className="common-btn me-3"
                            >
                                {exportFunction ? "Saving" : "Save"}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    );
};

export default BillingGuideModal;
